import app from 'flarum/forum/app';
import Component from "flarum/common/Component";
import DiscussionList from 'flarum/components/DiscussionList';
import LinkButton from 'flarum/common/components/Button';

export default class NoSearchResults extends Component {
    oninit(vnode) {
        this.history = app.history;
        this.searchTerm = vnode.attrs.searchTerm || '';
        this.previous = this.history.canGoBack() ? this.history.getPrevious() : null;

        if (this.history.canGoBack()) {
            this.backUrl = this.history.backUrl();
        }
    }

    view() {
        const { searchTerm, previous, backUrl } = this;
        const noResultsMessage = searchTerm ?
            `Sorry, there are no search results for "${searchTerm}"` :
            "Looks like you're ahead of the curve—no discussions have been started yet. Be the first to share your insights or ask a question!";

        return (
            <div className={`noSearchResults ${!searchTerm && 'noSearchResults-wide'}`}>
                <i className="far fa-comment-slash"></i>
                <div className="noSearchResults-text">
                    {noResultsMessage}
                </div>
                <LinkButton 
                    className="Button noSearchResults-button"
                    href={backUrl}
                    aria-label={previous?.title || 'Go back'}
                    onclick={() => this.goBack()}
                >
                    <i className="far fa-chevron-left"></i> Go Back
                </LinkButton>
            </div>
        );
    }

    goBack() {
        app.search.clear();
    
        if (app.current.matches(DiscussionList)) {
            app.current.refresh();
        } else {
            const slug = app.previous?.data?.discussion?.slug();
            slug ? m.route.set(`/d/${slug}`) : this.history.back();
        }
    }

    onremove() {
        this.searchTerm && setTimeout(() => app.search.clear(), 300);
    }
}
